import React, { useContext, useState, useEffect,useReducer } from 'react';
import { Row, Col, Form, Tabs, Modal, message } from 'antd';
import {
  Button,
  Input,
  Layout,
  Select,
  Phone,
  MessageSteps,
  Footer,
  Checkbox,
} from 'components';

import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import IdentityIcon from 'assests/icons/identitiy.icon';
import ProfileIcon from 'assests/icons/profile.icon';
import CompanyIcon from 'assests/icons/company.icon';

import '../../Messages/message-steps/steps.less';
import './create-title-step-1.less';

import * as alphaService from '../../../services/alpha.service';
import { customMessages } from 'utils';
import IdentityTitle from './Steps/identity';
import CompanyTitle from './Steps/company';

const { TabPane } = Tabs;


const createTitleSteps = [
  {
    text: 'Kimlik',
    icon: <IdentityIcon />,
  },
  {
    text: 'Şirket',
    icon: <CompanyIcon />,
  },
  {
    text: 'Ünvan',
    icon: <ProfileIcon />,
  },
];


const ChooseTitle = () => {
  //const [form] = Form.useForm();
  const history = useHistory();
  const [titleData, setTitleData] = useState({});
  const dispatch = useDispatch();
  const [firmExist, setFirmExist] = useState(false);
  const [current,setCurrent] = useState(-1);

  const [loading,setLoading] = useState(false);

  const [modalInfo, setModalInfo] = useState(false);

  function getUserData() {
    setLoading(true);
    dispatch({
      type: 'TITLE_DATA_FETCHING'
    });
    alphaService
      .corporateGetFirm()
      .then((result) => {
        setTitleData(result);
        if (result.user) {    
          if (result.userFirm.status==="ALPHANUMERIC_INPROGRESS" || result.userFirm.status==="SIGNUP_INPROGRESS")
          {
            history.push({pathname:`/Title`, state:{statues:"error",errorMessage:customMessages.getMessage("977")}});
          }  
          if (result.userFirm.status==="AVAILABLE" || result.userFirm.status== "ALPHANUMERIC_REJECTED")
          { 
            setFirmExist(true);
          }
        }
        else
        {
          setFirmExist(false);
        }
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      }).finally(() => {
        dispatch({
          type: 'TITLE_DATA_FETCHED'
        });
      setCurrent(0);
      });
  }

  const updateFirmData = (newValue) => {
    setTitleData(newValue);
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Layout
      customMenuRender={() => (
        <MessageSteps 
          items={createTitleSteps}
          current={current}
          status="process"
        />
      )}
    >
     

      
      <div className="choose-title-page">
     {current==0 &&
          <IdentityTitle 
          firmData={titleData}
           newFirm={!firmExist} 
           updateCurrent={(current)=> setCurrent(current)} 
          onFirmUpdate={(newValue)=>updateFirmData(newValue)}
          ></IdentityTitle>
        }
        {current==1 && 
      
          <CompanyTitle  
            firmData={titleData}
            newFirm={!firmExist}
            updateCurrent={(current)=> setCurrent(current)} 
          ></CompanyTitle>
      }
      </div>
      <Modal
        title="Önemli Bilgilendirme"
        visible={modalInfo}
        className='info-modal'
        onCancel={() => setModalInfo(false)}
        footer={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyItems: 'center',
            }}
          >
            <Button
              style={{ marginLeft: '0' }}
              type="primary"
              onClick={() => setModalInfo(false)}
            >
              Anladım
            </Button>
          </div>
        }
      >
        <div style={{ textAlign: 'justify', paddingRight: '2px' }}>
          <p>
            Bilgi Teknolojileri ve İletişim Kurulu'nun{' '}
            <strong>16.12.2025</strong> tarih ve{' '}
            <strong>2025/DK-YED/399</strong> sayılı kararı kapsamında,
            uygulamadan kişiye (A2P) SMS ve MMS gibi mesaj hizmetlerini sunan
            işletmecilerin bu hizmetler özelinde alacağı abonelik başvuruları ve
            bu başvuruya ilişkin bilgi ve belgeleri Kayıtlı Elektronik Posta
            (KEP) vasıtasıyla alması <br /> <strong>1 Nisan 2026</strong>{' '}
            itibarıyla zorunlu tutulmuştur.
          </p>
          <p>
            Bu kapsamda Mesaj Üssü üzerinden yapılacak yeni abonelik
            (unvan/mesaj başlığı) başvurularına ilişkin bilgi ve belgelerin KEP
            aracılığıyla iletilmesi gerekecektir.
          </p>
          <p style={{ marginBottom: '0' }}>
            Mesaj Üssü kullanımınızın kesintiye uğramaması için, Kayıtlı
            Elektronik Posta Sistemine İlişkin Usul ve Esaslar Hakkında
            Yönetmelik kapsamında kayıtlı elektronik posta gönderme yeteneğine
            sahip <strong>KEP hesabınız</strong> bulunmuyorsa{' '}
            <strong>1 Nisan 2026</strong> tarihine kadar KEP hesabı edinmeniz
            önerilir.
          </p>
        </div>
      </Modal>
      <Footer />
    </Layout>
  );
};

export default ChooseTitle;
